<app-mobile-filters-modal (closeModal)="closeModal()">
  <app-helix-book-search-panel></app-helix-book-search-panel>
</app-mobile-filters-modal>
